import React, {useEffect, useState} from 'react';
import {Field, Form, Formik} from 'formik';
import {EducationPhase} from 'src/types/enums';
import Button from 'src/components/button';
import UniversityDropdown from 'src/views/admin/UniversityDropdown';
import ScholarshipProgramDropdown from 'src/components/ScholarshipProgramDropdown';
import {fetchSlugForUniversity} from 'src/redux/admin/actions/universities';
import {useBoolean} from 'src/hooks/useBoolean';
import Loading from 'src/views/admin/Loading';
import FieldComponent from 'src/components/FieldComponent';
import {UGSSStudentValues} from './types';
import LoadingIcon from 'shared/components/loading';

export const fields = [
  {type: 'textbox', name: 'undergraduateInfo.collegeStudentIdentifier', required: true},
  {type: 'checkbox', name: 'demo'},
  {type: 'email', name: 'email', required: true},
  {type: 'textbox', name: 'firstName', required: true},
  {type: 'textbox', name: 'lastName', required: true},
  {type: 'tel', name: 'mobile'},
  {type: 'number', name: 'undergraduateInfo.term'},
  {type: 'textbox', name: 'undergraduateInfo.classYear'},
];

const CreateUGSSStudent = (props: {
  createStudent: (values: UGSSStudentValues) => Promise<void>;
}): React.ReactElement => {
  const [universityId, setUniversityId] = useState<string | null>(null);
  const [slug, setSlug] = useState('');
  const loading = useBoolean(true);
  const saving = useBoolean(false);

  useEffect(() => {
    if (!universityId) {
      return;
    }

    loading.setTrue();
    fetchSlugForUniversity(universityId).then(setSlug).then(loading.setFalse);
  }, [universityId]);

  return (
    <div>
      <UniversityDropdown
        autoSelectFirstUniversity
        value={universityId}
        onChange={setUniversityId}
        educationPhases={[EducationPhase.UNDERGRADUATE]}
      />
      {loading.value && <Loading />}
      {!loading.value && (
        <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            email: '',
            mobile: '',
            slug,
            educationPhase: EducationPhase.UNDERGRADUATE,
            undergraduateInfo: {
              collegeStudentIdentifier: '',
              term: null,
              classYear: null,
            },
            demo: true,
            scholarshipProgramId: null,
          }}
          onSubmit={props.createStudent}
        >
          {({values}): React.ReactElement => (
            <Form>
              <Field name="scholarshipProgramId" type="text">
                {({field: {name, value}, form: {setFieldValue}}): React.ReactElement => (
                  <ScholarshipProgramDropdown
                    disabled={!universityId}
                    educationPhase={EducationPhase.UNDERGRADUATE}
                    sponsorId={universityId}
                    value={value}
                    onChange={(id): void => setFieldValue(name, id)}
                  />
                )}
              </Field>
              {fields.map(({name, type, required}) => (
                <FieldComponent key={name} type={type} name={name} required={!!required} />
              ))}
              <Button
                disabled={saving.value}
                onClick={(): void => {
                  saving.setTrue();
                  props.createStudent(values).then(saving.setFalse);
                }}
              >
                {saving.value ? <LoadingIcon /> : 'Create'}
              </Button>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default CreateUGSSStudent;
